import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';

import { colors, getFontStyle } from '@cabonline/ui-shared';
import { Global, css } from '@emotion/react';
import emotionReset from 'emotion-reset';
import { FC } from 'react';

import { useMenu, useModal } from '../context';

const GlobalStyle: FC = () => {
  const { isMenuOpen } = useMenu();
  const { isAnyModalOpen } = useModal();
  const shouldLockScroll = isMenuOpen || isAnyModalOpen;
  return (
    <Global
      styles={css`
        ${emotionReset}
        *,
        *::after,
        *::before {
          box-sizing: border-box;
          -moz-osx-font-smoothing: grayscale;
          -webkit-font-smoothing: antialiased;
          font-smoothing: antialiased;
        }

        html,
        body {
          overflow: ${shouldLockScroll ? 'hidden' : 'unset'};
        }

        button {
          border: none;
          margin: 0;
          padding: 0;
          width: auto;
          overflow: visible;
          background: transparent;
          color: inherit;
          line-height: normal;
        }

        body {
          ${getFontStyle('m')};
        }

        body,
        button {
          font-family: 'Plus Jakarta Sans', sans-serif;
        }

        html {
          font-size: 16px;
        }

        * {
          outline-color: #000;
        }

        .react-datepicker {
          ${getFontStyle('s')};
          font-family: 'Plus Jakarta Sans', sans-serif;
        }

        .react-datepicker-wrapper {
          width: 100%;
        }

        .react-datepicker__day--keyboard-selected {
          color: ${colors.black};
          background-color: ${colors.gray4};
          &:hover {
            background-color: ${colors.gray4};
            outline: 1px solid ${colors.black};
          }
        }

        .react-datepicker__day--selected {
          color: ${colors.black};
          background-color: ${colors.primary};
          &:hover {
            background-color: ${colors.primary};
            outline: 1px solid ${colors.black};
          }
        }

        .react-datepicker__day--highlighted {
          color: ${colors.black};
          background-color: ${colors.primary};

          &:hover {
            background-color: ${colors.primary};
            outline: 1px solid ${colors.black};
          }
        }

        .react-datepicker__month-read-view,
        .react-datepicker__year-read-view {
          font-weight: 700;
          color: ${colors.black};
        }

        .react-datepicker__month-read-view--down-arrow,
        .react-datepicker__year-read-view--down-arrow {
          border-color: ${colors.gray2};
          top: 4px;
        }

        .react-datepicker__month-dropdown,
        .react-datepicker__year-dropdown {
          background-color: ${colors.white};
          border: 1px solid ${colors.gray3};
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .react-datepicker__month-dropdown {
          overflow: hidden;
        }

        .react-datepicker__month-option,
        .react-datepicker__year-option {
          color: ${colors.black};

          &:hover {
            background-color: ${colors.gray5};
          }
        }

        .react-datepicker__month-option--selected_month,
        .react-datepicker__year-option--selected_year {
          background-color: ${colors.primary};
          color: ${colors.black};

          &:hover {
            background-color: ${colors.primary};
          }
        }
      `}
    />
  );
};

export default GlobalStyle;
